import * as CryptoJS from 'crypto-js';
export class Constants {
    public static englishLocale: any = {
        firstDayOfWeek: 0,
        dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
        monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        today: "Today",
        clear: "Clear",
    };

    public static koreanLocale: any = {
        firstDayOfWeek: 0,
        dayNames: ["일요일", "월요일", "화요일", "수요일", "목요일", "금요일", "토요일"],
        dayNamesShort: ["일", "월", "화", "수", "목", "금", "토"],
        dayNamesMin: ["일", "월", "화", "수", "목", "금", "토"],
        monthNames: ["1월", "2월", "3월", "4월", "5월", "6월", "7월", "8월", "9월", "10월", "11월", "12월"],
        monthNamesShort: ["1월", "2월", "3월", "4월", "5월", "6월", "7월", "8월", "9월", "10월", "11월", "12월"],
        today: "오늘",
        clear: "초기화",
    };

    public static vietnamLocale: any = {
        firstDayOfWeek: 0,
        dayNames: ["Chủ nhật", "Thứ hai", "Thứ ba", "Thứ tư", "Thứ năm", "Thứ sáu", "Thứ bảy"],
        dayNamesShort: ["CN", "T2", "T3", "T4", "T5", "T6", "T7"],
        dayNamesMin: ["CN", "T2", "T3", "T4", "T5", "T6", "T7"],
        monthNames: [
            "Tháng 1", "Tháng 2", "Tháng 3", "Tháng 4", "Tháng 5", "Tháng 6",
            "Tháng 7", "Tháng 8", "Tháng 9", "Tháng 10", "Tháng 11", "Tháng 12"
        ],
        monthNamesShort: [
            "Th1", "Th2", "Th3", "Th4", "Th5", "Th6",
            "Th7", "Th8", "Th9", "Th10", "Th11", "Th12"
        ],
        today: "Hôm nay",
        clear: "Xóa",
    };

    public static getNowKR() {
        const nowUTC = new Date();
        const utcKR = nowUTC.getTime() + nowUTC.getTimezoneOffset() * 60000;
        const now = new Date(utcKR + 9 * 60 * 60000)
        return now;
    }


    public static getDayIndex = (theDate: string | Date): number => {
        const date = new Date(theDate);
        const jsIndex = date.getDay();
        return jsIndex + 1;
    };

    public static dayNamesShort = {
        en: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        ko: ['일', '월', '화', '수', '목', '금', '토'],
        vi: ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7']
    };

    public static dayNamesLong = {
        en: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        ko: ["일요일", "월요일", "화요일", "수요일", "목요일", "금요일", "토요일"],
        vi: ["Chủ nhật", "Thứ hai", "Thứ ba", "Thứ tư", "Thứ năm", "Thứ sáu", "Thứ bảy"]
    };

    public static dayName = (dayIndex: number): string => {
        const jsIndex = (dayIndex - 1 + 7) % 7;
        const language = this.getLang().toUpperCase() === 'KO' ? 'ko' : this.getLang().toUpperCase() === 'VI' ? 'vi' : 'en';
        return this.dayNamesShort[language]?.[jsIndex] || '';
    }

    public static dayNameLong = (dayIndex: number): string => {
        const jsIndex = (dayIndex - 1 + 7) % 7;
        const language = this.getLang().toUpperCase() === 'KO' ? 'ko' : this.getLang().toUpperCase() === 'VI' ? 'vi' : 'en';
        return this.dayNamesLong[language]?.[jsIndex] || '';
    }

    public static getDateFormat(): string {
        switch (this.getLang()) {
            case 'ko': // Korean
                return "yy/mm/dd";
            case 'vi': // Vietnamese
                return "dd/mm/yy";
            case 'en': // English
                return "mm/dd/yy";
            default:
                return "yy년 mm월 dd일"; // fallback
        }
    }

    public static GetTimeBooking: string = "GetTimeBooking";
    public static Booking: string = "Booking";
    public static StoreSchedulesPost = 'StoreSchedulesPost'
    public static File: string = 'File';
    public static Upload: string = 'Upload';
    public static Uploads: string = 'Uploads';
    public static CommonMst: string = 'CommonMst';
    public static GetCountry: string = 'GetCountry';
    public static GetEmailByPhoneNumber: string = "GetEmailByPhoneNumber";
    public static UpdatePassword: string = 'UpdatePassword';
    public static UpdatePasswordByUsername: string = 'UpdatePasswordByUsername';
    public static UpdateProfile: string = 'UpdateProfile';
    public static GetIdByPhoneNumber = "GetIdByPhoneNumber";
    public static Setting = "Setting"
    public static PostData = "PostData"
    public static CreateEmployee = "CreateEmployee"
    public static Store = "Store"
    public static SettingServiceGet = "SettingServiceGet"
    public static ServicePost = "ServicePost"
    public static StoreSettings = "StoreSettings"
    public static StoreSetting = "StoreSetting"
    public static BookingAdmin = "BookingAdmin"
    public static AddPoint = "AddPoint"
    public static UploadCover = "UploadCover"
    public static AlbumPost = "AlbumPost"
    public static UploadMedia = "UploadMedia"
    public static ReadNotice = "ReadNotice"
    public static Export = "Export"
    public static ValidateUsername = "ValidateUsername"
    public static GetCalendarKey = "GetCalendarKey"
    public static MembershipManagement = "MembershipManagement"
    public static StoreSchedule = "StoreSchedule";
    public static StaffManagement = "StaffManagement";
    public static PrepaidManagement = "PrepaidManagement";

    // Identities
    public static Identities: string = 'Identities';
    public static Auth: string = 'Auth';
    public static Authenticate: string = 'Authenticate';
    public static Menu: string = 'Menu';
    public static Get: string = 'Get';
    public static Post: string = 'Post';
    public static Update: string = 'Update';
    public static Delete: string = 'Delete';
    public static Save: string = 'Save';
    public static CreateUser: string = 'CreateUser';
    public static Category: string = 'Category';
    public static BomMst: string = 'BomMst';
    public static Copy: string = 'Copy';
    public static ValidToken: string = 'ValidToken';
    public static NaverMap: string = 'NaverMap';
    public static Common: string = 'Common';


    //Settings
    //public static Settings : string =`${ConfigService.apiUrl}/${"Settings"}`;
    public static Controller: string = "Setting";
    public static Banner: string = "Banner";
    public static FAQ: string = "FAQ";
    public static Notification: string = "Notification";
    public static Popup: string = "Popup";
    public static UserAuth: string = "Auth";
    public static SaveSystem: string = "SaveSystem";
    public static Config: string = "Config";
    public static Coupon: string = "Coupon";
    public static WorkingTime: string = "WorkingTime";


    public static Member: string = "Member";
    //Product
    public static Products: string = "Products";
    public static BomHD: string = "BomHD";
    public static Duplicate: string = "Duplicate";

    //Order
    public static OrderManagement: string = "OrderManagement"
    public static OrderCompany: string = "OrderCompany"
    public static CheckStock: string = "CheckStock"
    public static TranferWMS: string = "TranferWMS"
    public static CancelOrder: string = "CancelOrder"
    public static MappingOrder: string = "MappingOrder"
    public static Return: string = "Return";
    public static Cancel: string = "Cancel";
    public static Sales: string = "Sales";
    public static ServiceManagement: string = "ServiceManagement"
    public static BookingRegistration: string = "BookingRegistration"

    //return
    public static ReturnManagement: string = 'ReturnManagement';


    public static CurrentUser: string = 'CurrentUserStore'; // local storage
    public static CurrentMenu: string = 'CurrentMenuStore'; // local storage
    public static CurrentId: string = 'CurrentIdStore'; // local storage
    public static IsAdminLogin: string = 'IsAdminLogin'; // local storage
    public static strNm: string = 'strNm'; // local storage
    public static Language: string = 'LanguageStore'; // local storage
    public static CartTemp: string = 'CartTemp'; // local storage

    // api get ip
    public static ipify: string = 'https://api.ipify.org?format=json';


    public static showError(errorMessages: any[]) {
        let message = '';
        errorMessages.forEach((x: any) => {
            message += x?.errorMessage ?? x?.ErrorMessage + '\n\n'
        });

        return message;
    }

    public static getLang() {
        var language = localStorage.getItem(Constants.Language);
        if (!language)
            language = "ko";
        return language;
    }


    public static activeYNDropDown = [
        { key: 'Y', value: 'Y' },
        { key: 'N', value: 'N' },
    ]

    public static getActiveFilter(translate: any): ActiveFilterItem[] {
        return [
            { key: 'A', value: translate.instant('LANGCODE.COMOLB0012') },
            { key: 'Y', value: 'Y' },
            { key: 'N', value: 'N' },
        ];
    }

    public static encryptWithKey(message: string, key: string) {
        const encrypted = CryptoJS.AES.encrypt(message, key).toString();
        return encrypted;
    }

    public static decryptWithKey(encryptedBase64: string, key: string) {
        const decrypted = CryptoJS.AES.decrypt(encryptedBase64, key);
        return decrypted.toString(CryptoJS.enc.Utf8);
    }

    public static formatStringDateYYYMMDDHHMMSS(dateString: any): string {
        const date = new Date(dateString);

        if (isNaN(date.getTime())) {
            throw new Error("Invalid date string");
        }

        date.setHours(date.getHours() + 9);

        const pad = (num: number) => String(num).padStart(2, '0');

        const year = date.getFullYear();
        const month = pad(date.getMonth() + 1);
        const day = pad(date.getDate());
        const hours = pad(date.getHours());
        const minutes = pad(date.getMinutes());
        const seconds = pad(date.getSeconds());

        const lang = this.getLang();

        const ret = lang.toUpperCase() == 'KO' ? `${year}-${month}-${day} ${hours}:${minutes}:${seconds}` :
            lang.toUpperCase() == 'VI' ? `${day}-${month}-${year} ${hours}:${minutes}:${seconds}` : `${month}-${day}-${year} ${hours}:${minutes}:${seconds}`;
        return ret;
    }

    public static swapMonthYearButtons() {
        setTimeout(() => {
            const monthButton = document.querySelector('.p-datepicker-month');
            const yearButton = document.querySelector('.p-datepicker-year');

            if (monthButton && yearButton) {
                const parent = monthButton.parentElement;

                if (parent) {
                    parent.insertBefore(yearButton, monthButton);
                }

                yearButton.innerHTML = `${yearButton.textContent?.trim()}년`;
                monthButton.innerHTML = `${monthButton.textContent?.trim()}`;
            }
        }, 50);
    }

    public static Admin = 1
    public static Employee = 2
    public static Request: number = 1;
    public static Approve: number = 2;
    public static Processing: number = 3;
    public static Done: number = 4;
    public static Cancelled: number = 5;
    public static ServiceCategories: string = 'ServiceCategories';
    public static CreateUserBySignUp: string = 'CreateUserBySignUp';
    public static CheckUserName: string = 'CheckUserName';
    public static GetGeocoding: string = 'GetGeocoding';
    public static GetDataWorkingTime: string = 'GetDataCalendar';
    public static GetStoreSchedules: string = 'GetStoreSchedules';
    public static InsertOrUpdate: string = 'InsertOrUpdate';
    public static GetAllEmployee: string = 'GetAllEmployee';
    public static PetType_Dog = 1
    public static PetType_Cat = 2

    public static paymentType = {
        Cash: 1,
        CashBill: 2,
        Card: 3,
        Points: 4,
        EasyPay: 5,
        Bank: 6
    }

    public static P_PAGEROW = 20;
    public static P_PAGEROW_POPUP = 10;
}

export interface ActiveFilterItem {
    key: string;
    value: string;
}